import { Instagram, Youtube, Facebook, Music2, MapPin, Phone, Mail } from "lucide-react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { SOCIALS, CONTACT, IMAGES } from "../../data";

const ICONS = { instagram: Instagram, youtube: Youtube, facebook: Facebook, music: Music2 };

export default function Footer() {
  const navigate = useNavigate();
  const goBook = () => {
    navigate("/book");
    window.scrollTo({ top: 0 });
  };
  return (
    <footer className="relative bg-[#0C0C0C] border-t border-white/10 pt-20 md:pt-28 pb-10 px-6 lg:px-10" data-testid="footer">
      <div className="mx-auto max-w-[1400px]">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <img
              src={IMAGES.logo}
              alt="War Room Performance"
              data-testid="footer-logo"
              className="h-24 md:h-28 w-auto mb-8 opacity-95"
            />
            <p className="font-body text-xs uppercase tracking-[0.3em] text-teal mb-6">
              / Ready to train?
            </p>
            <h2 className="font-display font-700 uppercase leading-[0.85] tracking-tighter text-white text-6xl md:text-7xl lg:text-8xl">
              War Room
            </h2>
            <button
              onClick={goBook}
              data-testid="footer-book-btn"
              className="mt-8 font-display uppercase tracking-wide text-base px-8 py-4 bg-hotpink text-white hover:bg-white hover:text-ink transition-colors duration-300 rounded-sm"
            >
              Book Free Class
            </button>
          </div>

          <div className="grid sm:grid-cols-2 gap-10 lg:justify-items-end">
            <div className="space-y-4">
              <p className="font-body text-[11px] uppercase tracking-[0.25em] text-neutral-500">Visit</p>
              <div className="flex items-start gap-3 text-neutral-300 font-body text-sm">
                <MapPin size={16} className="text-hotpink mt-0.5 shrink-0" />
                <span>{CONTACT.address}</span>
              </div>
              <a href={`tel:${CONTACT.phoneHref}`} data-testid="footer-phone" className="flex items-center gap-3 text-neutral-300 hover:text-white font-body text-sm transition-colors">
                <Phone size={16} className="text-hotpink shrink-0" />
                {CONTACT.phone}
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="flex items-center gap-3 text-neutral-300 hover:text-white font-body text-sm transition-colors">
                <Mail size={16} className="text-hotpink shrink-0" />
                {CONTACT.email}
              </a>
            </div>

            <div className="space-y-4">
              <p className="font-body text-[11px] uppercase tracking-[0.25em] text-neutral-500">Follow</p>
              <div className="flex gap-3">
                {SOCIALS.map((s) => {
                  const Icon = ICONS[s.icon];
                  return (
                    <motion.a
                      key={s.label}
                      href={s.href}
                      target="_blank"
                      rel="noreferrer"
                      whileHover={{ y: -4 }}
                      data-testid={`social-${s.label.toLowerCase()}`}
                      aria-label={s.label}
                      className="h-11 w-11 grid place-items-center rounded-full border border-white/15 text-neutral-300 hover:border-teal hover:text-teal transition-colors"
                    >
                      <Icon size={18} />
                    </motion.a>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4">
          <p className="font-body text-xs text-neutral-500">
            © {new Date().getFullYear()} War Room Performance. Christ-centered. All rights reserved.
          </p>
          <p className="font-body text-xs text-neutral-500 uppercase tracking-[0.2em]">
            The Art of Eight Limbs
          </p>
        </div>
      </div>
    </footer>
  );
}
